import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "./../context/AppContext";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
//Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import Table from "react-bootstrap/Table";

import $ from "jquery";
import { Link } from "react-router-dom";
import Form from "react-bootstrap/Form";
import SurahFatiha from "../assets/SurahFatiha.mp3";
import ic_delete from "../assets/images/ic_delete.svg";
import ic_edit from "../assets/images/ic_edit.svg";
import ic_eyes from "../assets/images/ic_eyes.svg";
import Modal from "react-bootstrap/Modal";
import { ToastMsg } from "./TostMsg";
import {
  DeleteCallWithErrorResponse,
  multipartPostCallWithErrorResponse,
  PostCallWithAuthTokenWithErrorResponse,
  putMultipartWithAuthCallWithErrorResponse,
  simpleGetCallWithErrorResponse,
} from "../api/ApiServices";
import ApiConfig from "../api/ApiConfig";
import {
  DEFAULT_LANG,
  DEFAULT_LANG_LABEL,
  LANGUAGES,
  buildSurahFormData,
  dirOf,
  emptyAyat,
  emptySurah,
  getLanguage,
  isDefaultLangBlank,
  mapSurahResponse,
} from "../api/multiLang";
import { Pagination } from "./Pagination";
import FormLoader from "./FormLoader";
import Tabs from "../sharedComponents/Tabs";

const HifzESurah = () => {
  const { sidebar, adminData } = useContext(AppContext);
  const [loader, setLoader] = useState(true);
  const [idEdit, setIdEdit] = useState("");
  const [viewDetails, setViewDetails] = useState({});
  const [activeLang,setActiveLang] = useState(DEFAULT_LANG)
  const [imageWidth, setImageWidth] = useState({
    sabaq: "100%",
    des: "100%",
  });
  const [addAyyat, setAddAyyat] = useState(emptySurah());

  // Field names for the language tab currently being edited.
  const activeLangMeta = getLanguage(activeLang);
  const langSuffix = activeLangMeta.suffix;
  const activeLangLabel = activeLangMeta.label;
  const isDefaultLang = activeLang === DEFAULT_LANG;
  const textDir = dirOf(activeLang);

  const nameKey = `sabaqName${langSuffix}`;
  const audioKey = `sabaqNameAudio${langSuffix}`;

  // Ayahs are single language by design, so they sit outside the tabs.
  const ayatKey = "ayatDetails";
  const currentAyatDetails = addAyyat[ayatKey] || [];

  // console.log(addAyyat,"hgdhcgc")
  // const pagination = () => {
  //   $(document).ready(function () {
  //     let table;
  //     if ($.fn.dataTable.isDataTable("#table_id")) {
  //       table = $("#table_id").DataTable();
  //     } else {
  //       table = $("#table_id").DataTable({
  //         ordering: false,

  //         language: {
  //           search: "",
  //           searchPlaceholder: "Search...",
  //           sLengthMenu: "Entries per page _MENU_",
  //         },
  //       });
  //     }
  //   });
  // };
  const [AddNewGroup, setAddNewGroup] = useState(0);

  const [add, setAdd] = useState(false);
  const handleAddClose = () => {
    setAdd(false);
    setIdEdit("");
    setValidated(false)
    setActiveLang(DEFAULT_LANG)
    setAddAyyat(emptySurah());
  };
  const handleAddShow = () => setAdd(true);
  const [deleteId, setDeleteId] = useState("");
  const [lasatSabaqId, setLsatSabaq] = useState("");
  const [saveBotton, setSaveBotton] = useState(false);

  const [deleteModal, setDelete] = useState(false);
  const handleDeleteClose = () => setDelete(false);
  const handleDeleteShow = () => setDelete(true);

  const [viewModal, setView] = useState(false);
  const handleViewClose = () => setView(false);
  const handleViewShow = () => setView(true);

  const [validated, setValidated] = useState(false);
  const [hifzlist, setHifzlist] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const startIndex = currentPage * 15;
  const endIndex = startIndex + 15;
  const changePage = ({ selected }) => {
    setCurrentPage(selected);
  };
  const pageCount = Math.ceil(hifzlist?.length / 15);
  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    event.preventDefault();
    // The required fields live on the default language tab, and only the
    // open tab is mounted -- so a blank one is invisible to checkValidity
    // from any other tab. Read the state and send the admin back there.
    if (isDefaultLangBlank(addAyyat, "sabaqName")) {
      event.stopPropagation();
      setValidated(true);
      if (!isDefaultLang) {
        setActiveLang(DEFAULT_LANG);
        ToastMsg("error", `Please Enter Surah Name (${DEFAULT_LANG_LABEL})`);
      }
      return;
    }
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      addAyyatApi();
    }

    setValidated(true);
  };

  const addAyyatApi = () => {
    handleAddClose();
    setLoader(true);

    const payLoadFormData = buildSurahFormData({
      form: addAyyat,
      categoryId: 3,
      userId: Number(adminData.user_id),
      isEdit: idEdit === "edit",
      surahNo: lasatSabaqId + 1,
    });

    idEdit === "edit"
      ? putMultipartWithAuthCallWithErrorResponse(
          ApiConfig.SUBAQUPDATHIFZ,
          payLoadFormData
        ).then((res) => {
          setLoader(false);
          if (res.json && res.json?.success === true) {
            ToastMsg("success", res.json.message);
            HafizListApi();
            setSaveBotton(false);
          } else {
            ToastMsg("error", res.json.message);
          }
        })
      : multipartPostCallWithErrorResponse(
          ApiConfig.SUBAQADDHIFZ,
          payLoadFormData
          // payLoadFormDataNew
        )
          .then((res) => {
             setLoader(false);
            if (res.json && res.json?.success === true) {
              ToastMsg("success", res.json.message);
              HafizListApi();
              setSaveBotton(false);
            } else {
              ToastMsg("error", res.json.message);
            }
          })
          .catch((err) => {
             setLoader(false);

            ToastMsg("error", "something went wrong");
          });
  };
  useEffect(() => {
    HafizListApi();
  }, []);
  const HafizListApi = () => {
  

    simpleGetCallWithErrorResponse(ApiConfig.SUBAQLIST + `?categoryId=${3}`)
      .then((res) => {
        setLoader(false);

        if (res.json && res.json?.success === true) {
          setHifzlist(res.json?.data.allSabaq);
          setLsatSabaq(
            res.json?.data.allSabaq.length

          );
          setAddAyyat(emptySurah());
        } else {
          ToastMsg("error", res.json.message);
        }
      })
      .catch((err) => {
         setLoader(false);

        ToastMsg("error", "something went wrong");
      });
  };
  //
  const hifzLisDeleteApi = () => {
    const body = {
      categoryId: 3,
      sabaqId: deleteId,
    };
  
    DeleteCallWithErrorResponse(
      ApiConfig.DELETEAPI,

      JSON.stringify({
        ...body,
      })
    )
      .then((res) => {
        setLoader(false);
        handleDeleteClose();
        if (res.json && res.json?.success === true) {
          ToastMsg("success", res.json.message);
          HafizListApi();
        } else {
          ToastMsg("error", res.json.message);
        }
      })
      .catch((err) => {
        setLoader(false);

        ToastMsg("error", "something went wrong");
      });
  };
  //
  const EditListApi = (id) => {
  
 simpleGetCallWithErrorResponse(ApiConfig.EDITHIFZ + `?sabaqId=${id}`)
      .then((res) => {
        setLoader(false);

        if (res.json && res.json?.success === true) {
          setAddAyyat(mapSurahResponse(res.json.data));
          setIdEdit("edit");
          handleAddShow();
        } else {
          ToastMsg("error", res.json.message);
        }
      })
      .catch((err) => {
        setLoader(false);

        ToastMsg("error", "something went wrong");
      });
  };

  const viewListApi = (id) => {
  

    simpleGetCallWithErrorResponse(ApiConfig.EDITHIFZ + `?sabaqId=${id}`)
      .then((res) => {
        setLoader(false);

        if (res.json && res.json?.success === true) {
          setViewDetails(res.json.data);
          handleViewShow();
        } else {
          ToastMsg("error", res.json.message);
        }
      })
      .catch((err) => {
        setLoader(false);

        ToastMsg("error", "something went wrong");
      });
  };
  return (
    <main
      id="cx-main"
      className={sidebar ? "admin-main" : "cx-active admin-main"}
    >
      <div className="heading-btn-main">
        <div className="heading-common">
          <label htmlFor="">Hifz-E-Surah</label>
        </div>
        <div className="add-btn">
          <button onClick={handleAddShow}>
            Add Sabaq
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              preserveAspectRatio="xMidYMid meet"
              viewBox="0 0 24 24"
            >
              <path fill="white" d="M11 19v-6H5v-2h6V5h2v6h6v2h-6v6Z" />
            </svg>
          </button>
        </div>
      </div>
      {/* ======================= START ADD ========================== */}
      <Modal
        show={add}
        onHide={handleAddClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {idEdit === "edit" ? "Update  Hifz-e-Surah" : "Add Hifz-e-Surah"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <div className="row">

              {/* One ordering for the whole record, not per language, so it
                  sits above the language tabs. */}
              <div className="col-md-6 mb-3">
                <Form.Label>Order No</Form.Label>
                <Form.Control
                  type="number"
                  min="1"
                  value={addAyyat?.orderNo}
                  onChange={(e) =>
                    setAddAyyat({ ...addAyyat, orderNo: e.target.value })
                  }
                />
              </div>
              

              {currentAyatDetails &&
                currentAyatDetails.map((item, index) => {
                  return (
                    <div
                      className="col-md-12 sub-group-main"
                      key={"testitem" + index}
                    >
                      <div className="row">
                        <h6 className="fw-bold">
                          Aayat No. <span>{index + 1}</span>
                        </h6>

                        <div className="col-md-12 mb-3">
                          <Form.Label>Aayat</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            dir="rtl"
                            value={item?.ayat}
                            onChange={(e) => {
                              setAddAyyat({
                                ...addAyyat,
                                [ayatKey]: currentAyatDetails.map(
                                  (item, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                          ...item,
                                          ayat: e.target.value,
                                        }
                                      : item;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Tarjama.
                          </Form.Control.Feedback>
                        </div>

                     

                        {idEdit ? (
                          <>
                            <div className="row d-flex">
                              <div className="col-md-12">
                                <label htmlFor="" className="key">
                                Aayat Audio
                                </label>
                              </div>
                              <div
                                className={
                                  imageWidth === "100%"
                                    ? "invisible"
                                    : "col-md-6 "
                                }
                              >
                                <Form.Label>
                                  {typeof item?.ayahAudio === "string"
                                    ? item?.ayahAudio.substring(
                                        item?.ayahAudio.length - 15,
                                        item?.ayahAudio.length
                                      )
                                    : ""}
                                </Form.Label>
                              </div>
                              <div className="col-md-12 mb-3">
                                <Form.Control
                                  type="file"
                                  accept="audio/mp3,audio/*;capture=microphone"
                                  name="sabaqAudio"
                                  style={{ width: imageWidth.des }}
                                  //  value={addSabaq?.sabaqAudio}
                                  onChange={(e) => {
                                    setImageWidth({
                                      ...imageWidth,
                                      des: "100%",
                                    });
                                    setAddAyyat({
                                      ...addAyyat,
                                      [ayatKey]: currentAyatDetails.map(
                                        (item, innerIndex) => {
                                          return index === innerIndex
                                            ? {
                                                ...item,
                                                ayahAudio:
                                                  e.target.files[0],
                                              }
                                            : item;
                                        }
                                      ),
                                    });
                                  }}
                                />

                                <Form.Control.Feedback type="invalid">
                                  Please Enter Sabaq Name
                                </Form.Control.Feedback>
                              </div>
                            </div>
                          </>
                        ) : (
                          <div className="col-md-12 mb-3">
                            <Form.Label> Aayat Audio </Form.Label>
                            <Form.Control
                              type="file"
                              accept="audio/mp3,audio/*;capture=microphone"
                              // value={addAyyat?.sabaqAudio}
                              onChange={(e) => {
                                setAddAyyat({
                                  ...addAyyat,
                                  [ayatKey]: currentAyatDetails.map(
                                    (item, innerIndex) => {
                                      return index === innerIndex
                                        ? {
                                            ...item,
                                            ayahAudio: e.target.files[0],
                                          }
                                        : item;
                                    }
                                  ),
                                });
                              }}
                            />

                            <Form.Control.Feedback type="invalid">
                              Please Enter Sabaq Name
                            </Form.Control.Feedback>
                          </div>
                        )}

                        <div className="col-md-4 mb-3">
                          <Form.Label>Waqf 1</Form.Label>
                          <Form.Control
                          maxLength={10}

                            type="text"
                            dir="rtl"
                            value={item?.waqf1}
                            onChange={(e) => {
                              setAddAyyat({
                                ...addAyyat,
                                [ayatKey]: currentAyatDetails.map(
                                  (item, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                          ...item,
                                          waqf1: e.target.value,
                                        }
                                      : item;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Choose Audio File.
                          </Form.Control.Feedback>
                        </div>
                        <div className="col-md-4 mb-3">
                          <Form.Label>Waqf 2</Form.Label>
                          <Form.Control
                          maxLength={10}
                            type="text"
                            dir="rtl"
                            value={item?.waqf2}
                            onChange={(e) => {
                              setAddAyyat({
                                ...addAyyat,
                                [ayatKey]: currentAyatDetails.map(
                                  (item, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                          ...item,
                                          waqf2: e.target.value,
                                        }
                                      : item;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Choose Audio File.
                          </Form.Control.Feedback>
                        </div>
                        <div className="col-md-4 mb-3">
                          <Form.Label>Waqf 3</Form.Label>
                          <Form.Control
                          maxLength={10}

                            type="text"
                            dir="rtl"
                            value={item?.waqf3}
                            onChange={(e) => {
                              setAddAyyat({
                                ...addAyyat,
                                [ayatKey]: currentAyatDetails.map(
                                  (item, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                          ...item,
                                          waqf3: e.target.value,
                                        }
                                      : item;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Choose Audio File.
                          </Form.Control.Feedback>
                        </div>
                      </div>
                      <div className="text-end">
                        <Link
                          to="#"
                          // className="btn btn-danger"
                          // onClick={() => setAddNewGroup(AddNewGroup - 1)}

                          className={
                            currentAyatDetails.length > 1
                              ? "btn btn-danger"
                              : "btn btn-secondary invisible"
                          }
                          // onClick={() => setAddNewGroup(AddNewGroup - 1)}
                          onClick={() => {
                            if (currentAyatDetails.length > 1) {
                              // addAyyat.ayatDetails.splice(index, 1);
                              const copySubDeatails = [...currentAyatDetails];
                              copySubDeatails.splice(index, 1);
                              setAddAyyat({
                                ...addAyyat,
                                [ayatKey]: copySubDeatails,
                              });
                            }

                            // const copySubDeatails = [...addSabaq.subsabaqDetails];
                            // copySubDeatails.sli
                          }}
                        >
                          Remove
                        </Link>
                      </div>
                    </div>
                  );
                })}

              <Link
                to="#"
                className="add-newSabaq-btn btn btn-primary"
                // {
                //   idEdit
                //     ? "add-newSabaq-btn invisible btn btn-secondary pe-none"
                //     : "add-newSabaq-btn btn btn-primary"
                // }
                // onClick={() => setAddNewGroup(AddNewGroup + 1)}
                onClick={() => {
                  let ayat = [
                    ...currentAyatDetails,

                    emptyAyat(),
                  ];
                  setAddAyyat({
                    ...addAyyat,
                    [ayatKey]: ayat,
                  });
                }}
              >
                + Add Sub Sabaq Details
              </Link>
               <div className=" sub-group-main">
                <Tabs
                  tabs={LANGUAGES}
                  className="mb-2"
                  activeKey={activeLang}
                  onChange={(e)=>setActiveLang(e)}
                />
                <div className="col-md-12 mb-3 ">
                <Form.Label>Surah Name ({activeLangLabel})</Form.Label>
                <Form.Control
                required={isDefaultLang}
                  type="text"
                  dir={textDir}
                  value={addAyyat?.[nameKey]}
                  onChange={(e) =>
                    setAddAyyat({ ...addAyyat, [nameKey]: e.target.value })
                  }
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Sabaq Name
                </Form.Control.Feedback>
              </div>

            
              {idEdit ? (
                <>
                  <div className="row d-flex">
                    <div className="col-md-12">
                      <label htmlFor="" className="key">
                        Sabaq Audio ({activeLangLabel})
                      </label>
                    </div>
                    <div
                      className={
                        imageWidth === "100%" ? "invisible" : "col-md-6 "
                      }
                    >
                      <Form.Label>
                        {typeof addAyyat?.[audioKey] === "string"
                          ? addAyyat?.[audioKey].substring(
                              addAyyat?.[audioKey].length - 15,
                              addAyyat?.[audioKey].length
                            )
                          : ""}
                      </Form.Label>
                    </div>
                    <div className="col-md-12 mb-3">
                      <Form.Control
                        type="file"
                        accept="audio/mp3,audio/*;capture=microphone"
                        // name="sabaqAudio"
                        style={{ width: imageWidth.sabaq }}
                        //  value={addSabaq?.sabaqAudio}
                        onChange={(e) => {
                          setImageWidth({ ...imageWidth, sabaq: "100%" });
                          setAddAyyat({
                            ...addAyyat,
                            [audioKey]: e.target.files[0],
                          });
                        }}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please Enter Sabaq Name
                      </Form.Control.Feedback>
                      
                    </div>
                    
                  </div>
                </>
              ) : (
                <div className="col-md-12 mb-3">
                  <Form.Label>Sabaq Audio ({activeLangLabel}) </Form.Label>
                  <Form.Control
                    type="file"
                    accept="audio/mp3,audio/*;capture=microphone"

                    // value={addAyyat?.sabaqAudio}
                    onChange={(e) =>
                      setAddAyyat({
                        ...addAyyat,
                        [audioKey]: e.target.files[0],
                      })
                    }
                  />

                  <Form.Control.Feedback type="invalid">
                    Please Enter Sabaq Name
                  </Form.Control.Feedback>
                </div>
              )}

              </div>

            </div>
            <div className="buttons-modal border-top pt-3 text-end ">
              <button className="me-2" type="submit" disabled={saveBotton}>
                {idEdit === "edit" ? "update" : "Save"}
              </button>
              <Link
                to="#"
                className=" bg-danger"
                onClick={() => {
                  setAddAyyat(emptySurah());
                  handleAddClose();
                  setIdEdit("");
                }}
              >
                Cancel
              </Link>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* ======================= END ADD ========================== */}

      {/* ======================= DELETE ========================== */}

      <Modal
        show={deleteModal}
        onHide={handleDeleteClose}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="delete-msg text-center">
            <label htmlFor="">Are you sure you want to delete this item?</label>
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <div className="buttons-modal    ">
            <button
              className="me-2 bg-danger"
              type="submit"
             
              onClick={() =>{
                handleDeleteClose()
                hifzLisDeleteApi()}}
            
            >
              Delete
            </button>
            <Link to="#" className="" onClick={handleDeleteClose}>
              Cancel
            </Link>
          </div>
        </Modal.Footer>
      </Modal>

      {/* ======================= END DELETE ========================== */}

      {/* ======================= VIEW ========================== */}
      <Modal
        show={viewModal}
        onHide={handleViewClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Hifz-e-Surah Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-6 mb-3">
              <div>
                  <label htmlFor="" className="key">
                    Sabaq No.
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                    {viewDetails?.SabaqId}
                  </label>
                </div>
              </div>
              <div className="col-md-12 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq Name
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                    {viewDetails?.sabaqName}
                  </label>
                </div>
              </div>
              <div className="col-md-12 mb-3">
                <div className="mb-2">
                  <label htmlFor="" className="key">
                    Sabaq Audio
                  </label>
                </div>
                <div>
                  <audio controls style={{ width: "100%", height: "38px" }}>
                    <source src={viewDetails?.sabaqAudio} type="audio/ogg" />
                    <source src={viewDetails?.sabaqAudio} type="audio/mpeg" />
                    Your browser does not support the audio element.
                  </audio>
                </div>
              </div>
              {viewDetails.ayatDetails &&
                viewDetails.ayatDetails?.length > 0 &&
                viewDetails.ayatDetails.map((ele, index) => {
                  return (
                    <div
                      className="sub-group-main row mb-3"
                      key={"testi" + index}
                    >
                      <h6 className="fw-bold mb-4">
                        Aayat No.<span>{ele?.ayatNo}</span>{" "}
                      </h6>
                      <div className="col-md-12 mb-3">
                        <div>
                          <label htmlFor="" className="value">
                            {ele?.ayat}
                          </label>
                        </div>
                      </div>
                      <div className="col-md-12 mb-3">
                        <div className="mb-2">
                          <label htmlFor="" className="key">
                          Aayat Audio
                          </label>
                        </div>
                        <div>
                          <audio
                            controls
                            style={{ width: "100%", height: "38px" }}
                          >
                            <source src={ele?.ayatAudioPath} type="audio/ogg" />
                            <source
                              src={ele?.ayatAudioPath}
                              type="audio/mpeg"
                            />
                            Your browser does not support the audio element.
                          </audio>
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            Waqf 1
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value">
                            {ele?.waqf1}
                          </label>
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            Waqf 2
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value">
                            {ele?.waqf2}
                          </label>
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            Waqf 3
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value">
                            {ele?.waqf3}
                          </label>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
            <div className="buttons-modal border-top pt-3 text-end ">
              <Link to="#" className="bg-danger" onClick={handleViewClose}>
                Cancel
              </Link>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
      {/* ======================= END VIEW ========================== */}
      {loader ? (
        <FormLoader />
      ) : (
        <div className="table-wrapper">
          <h6>Total Records : {hifzlist.length}</h6>
          <Table className="display" striped bordered hover size="lg">
            <thead>
              <tr>
                <th>Sr No.</th>
                <th>Surah List</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {hifzlist && hifzlist.length > 0
                ? hifzlist.slice(startIndex, endIndex).map((ele, index) => {
                    return (
                      <tr key={"ele" + index}>
                        <td>{index + 1 + startIndex}</td>

                        <td style={{ textAlign: "left" }}>{ele.sabaqName}</td>
                        <td className="action">
                          <Link
                            to="#"
                            className="icon edit"
                            onClick={() => {
                              // handleAddShow();
                              setIdEdit("edit");
                              setImageWidth({
                                ...imageWidth,
                                sabaq: "117px",
                                des: "117px",
                                Title: "117px",
                                subdesc: "117px",
                                mashq: "117px",
                              });
                              EditListApi(ele.sabaqId);
                            }}
                          >
                            <img src={ic_edit} alt="" />
                          </Link>
                          <Link
                            to="#"
                            className="icon view"
                            onClick={() => viewListApi(ele.sabaqId)}
                          >
                            <img src={ic_eyes} alt="" />
                          </Link>
                          <Link
                            to="#"
                            className="icon delete"
                            onClick={() => {
                              handleDeleteShow();
                              setDeleteId(ele.sabaqId);
                            }}
                          >
                            <img src={ic_delete} alt="" />
                          </Link>
                        </td>
                      </tr>
                    );
                  })
                : ""}
            </tbody>
          </Table>
          {hifzlist && hifzlist.length > 0 ? (
            <Pagination
              changePage={changePage}
              pageCount={pageCount}
              currentPage={currentPage}
            />
          ) : (
            <div>
              <h5 style={{ color: "red", textAlign: "center" }}>
                {" "}
                Records Not Found
              </h5>
            </div>
          )}
        </div>
      )}
    </main>
  );
};

export default HifzESurah;
